import RecruitmentDashboard from "./RecruitmentDashboard";
export default RecruitmentDashboard;